import { Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import useStyles from './styles/SitekeysTable.styles'

const SitekeysTableMobile = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{getTranslate('Entity')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Website')}</Typography>
      </div>
    </div>
  )
}
export default SitekeysTableMobile
